import { render } from "./FacturasIndex.vue?vue&type=template&id=384ca71b"
import script from "./FacturasIndex.vue?vue&type=script&lang=js"
export * from "./FacturasIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/procesos/FacturasIndex.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "384ca71b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('384ca71b', __exports__)) {
    api.reload('384ca71b', __exports__)
  }
  
  module.hot.accept("./FacturasIndex.vue?vue&type=template&id=384ca71b", () => {
    api.rerender('384ca71b', render)
  })

}


export default __exports__